<template>
  <div v-if="state === states.READY">
    <BasePageHeader>
      <div>
        <BasePageBreadcrumbs :breadcrumbs="breadcrumbs"></BasePageBreadcrumbs>
        <BasePageHeading>Candidates</BasePageHeading>
      </div>
    </BasePageHeader>

    <BasePageRefine>
      <SearchBox
        placeholder="Search candidates"
        @search="searchCandidates($event)"
      />
      <!-- @TODO 2023-02-08 Remove whene no longer required -->
      <!-- <CustomSelect
        v-if="openJobs"
        placeholder="All assessments"
        :options="openJobs"
        @selected="filterJob($event)"
      />
      <CustomSelect
        v-if="haveExamsLoaded"
        placeholder="All tests"
        :options="exams"
        @selected="filterExam($event)"
      /> -->
    </BasePageRefine>

    <BaseTabBar>
      <!-- No tabs on this page -->
    </BaseTabBar>

    <BaseWrapper v-if="loadingTableContent">
      <BaseTable>
        <BaseTHead>
          <tr>
            <BaseTHeadTh width="30%">
              &nbsp;
            </BaseTHeadTh>
            <BaseTHeadTh width="30%">
              &nbsp;
            </BaseTHeadTh>
            <BaseTHeadTh width="30%">
              &nbsp;
            </BaseTHeadTh>
          </tr>
        </BaseTHead>
        <BaseTBodyLoading
          :cols="3"
        >
        </BaseTBodyLoading>
      </BaseTable>
    </BaseWrapper>
    <div v-else-if="!loadingTableContent && candidates">
      <div v-if="candidates.length > 0">
        <div class="max-w-screen-xl mx-auto">
          <div class="px-6 overflow-x-auto">
            <CandidatesTable
              :show-search="false"
              :columns="columns"
              :table-data="candidates"
              :pagination-data="paginationData"
              :sort-data="sortData"
              @pagechanged="onPageChange($event)"
              @sort="onSort($event)"
              @refreshCandidates="fetchCandidates()"
              @candidateUpdated="candidateUpdated($event)"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        class="max-w-screen-xl px-6 mx-auto"
      >
        <JobsEmpty />
      </div>
    </div>
  </div>
  <div v-else-if="state === states.LOADING">
    <BasePageHeader>
      <div>
        <BasePageBreadcrumbs :breadcrumbs="breadcrumbs"></BasePageBreadcrumbs>
        <BasePageHeading>Candidates</BasePageHeading>
      </div>
    </BasePageHeader>
    <BaseLoader />
  </div>
  <div v-else-if="state === states.ERROR">
    <BaseErrorBlock />
  </div>
</template>

<script>
import JobsEmpty from '@components/Jobs/JobsEmpty'
import CandidatesTable from '@components/Candidates/CandidatesTable'
// @TODO 2023-02-08 Remove whene no longer required
// import CustomSelect from '@components/CustomSelect'
import SearchBox from '@components/TUI/SearchBox'

import organisationCandidatesApi from '@api/organisationCandidates'
import { mapGetters } from 'vuex'
import states from '@api/states'

export default {
  components: {
    JobsEmpty,
    CandidatesTable,
    // @TODO 2023-02-08 Remove whene no longer required
    // CustomSelect,
    SearchBox
  },

  data() {
    return {
      states,

      // Sort from here

      jobId: null,
      jobName: null,
      examId: null,
      searchQuery: null,
      searchSortBy: null,
      searchSortOrder: null,

      columns: [
        { key: 'name', sortable: true },
        { key: 'email', sortable: true },
        { key: 'last_updated', sortable: true }
      ],

      initialTab: 'testing',
      activeTab: 'testing',
      tabs: ['testing'],

      candidates: null,
      loadingTableContent: false,

      paginationData: {
        currentPage: 1,
        perPage: 50,
        totalPages: null,
        totalItems: 0
      },

      sortData: {
        key: null,
        order: null
      }
    }
  },

  computed: {
    ...mapGetters({
      haveJobsLoaded: 'jobs/haveJobsLoaded',
      openJobs: 'jobs/openJobs',
      haveExamsLoaded: 'exams/haveExamsLoaded',
      exams: 'exams/exams',
      organisationId: 'employers/organisationId',
      organisationName: 'organisations/name'
    }),

    /**
     * @return {Array}
     */
    breadcrumbs() {
      return [
        {
          name: this.organisationName
        }
      ]
    },

    /**
     * @return {string}
     */
    state() {
      if (this.error) {
        return states.ERROR
      }
      if (!this.candidates) {
        return states.LOADING
      }

      return states.READY
    },

    jobsSelect() {
      if (!this.jobs) {
        return
      }
      return this.jobs.map(job => {
        return {
          value: job.uuid,
          label: job.name
        }
      })
    },

    /**
     * Returns the current filters for the search
     *
     * @TODO 2019-11-26 Add text search
     *
     * @return {Object}
     */
    query() {
      return {
        job_id: this.jobId,
        exam_id: this.examId,
        page: this.paginationData.currentPage,
        per_page: this.paginationData.perPage,
        search: this.searchQuery,
        sort_by: this.searchSortBy,
        sort_order: this.searchSortOrder
      }
    },

    /**
     * Returns a string to use as the empty state text
     *
     * @return {String}
     */
    candidatesEmptyTitle() {
      if (this.jobId || this.examId || this.searchQuery) {
        return 'No candidates matched the filters'
      }
      return null
    }
  },

  mounted() {
    if (!this.haveJobsLoaded) {
      this.$store.dispatch('jobs/getJobs')
    }
    if (!this.haveExamsLoaded) {
      this.$store.dispatch('exams/getExams')
    }
    this.fetchCandidates()
  },

  methods: {
    /**
     * Fetch the candidates based on the current query
     */
    fetchCandidates() {
      this.loadingTableContent = true

      return organisationCandidatesApi.index(this.organisationId, this.query)
        .then(data => {
          this.loadingTableContent = false
          this.candidates = data.data
          if (data.meta) {
            this.paginationData.currentPage = data.meta.current_page
            this.paginationData.totalItems = data.meta.total
            this.paginationData.totalPages = data.meta.last_page
            // @NOTE 2019-12-19 Add in if required
            // this.paginationData.from = data.meta.from
            // this.paginationData.to = data.meta.to
            this.sortData.key = data.meta.sort_by
            this.sortData.order = data.meta.sort_order
          }
        })
        .catch(error => {
          this.loadingTableContent = false

          this.candidates = []
          throw error
        })
    },

    /**
     * One candidate has been updated, replace inline if possible
     *
     * @param {Object} updatedCandidate
     */
    candidateUpdated(updatedCandidate) {
      const candidate = this.candidates.find(candidate => {
        return candidate.id === updatedCandidate.id
      })

      if (!candidate) {
        this.fetchCandidates()
        return
      }

      const candidateIndex = this.candidates.indexOf(candidate)

      this.$set(this.candidates, candidateIndex, updatedCandidate)
    },

    /**
     * Filter has been chosen for a job
     *
     * @param {Object} job
     */
    filterJob(job) {
      this.jobId = job.id
      this.jobName = job.name
      this.fetchCandidates()
    },

    /**
     * Filter has been chosen for a exam
     *
     * @param {Object} exam
     */
    filterExam(exam) {
      this.examId = exam.id
      this.fetchCandidates()
    },

    /**
     * When the page changes...
     *
     * @param {Number} page
    */
    onPageChange(page) {
      this.paginationData.currentPage = page
      this.fetchCandidates()
    },

    /**
     * User selects a sort by
     *
     * @param {string} key
    */
    onSort({ key, order }) {
      console.log('Sort by ' + key + ' in ' + order)
      this.searchSortBy = key
      this.searchSortOrder = order
      this.fetchCandidates()
    },

    /**
     * Replace search query and trigger fetch attempts
     *
     * @param {string}
     */
    searchCandidates(query) {
      this.searchQuery = query
      this.fetchCandidates()
    }
  }
}
</script>
